import React from 'react';
import { Col as AntCol } from 'antd';
import type { ColProps } from 'antd';
import clsx from 'clsx';

/**
 * Thin wrapper over the Antd Col (per the antd wrapper standardization plan):
 * single import source through @common/components and a `wk-col` class hook.
 */
export const Col = ({ className, ...props }: ColProps) => (
  <AntCol {...props} className={clsx('wk-col', className)} />
);
